import React from "react"
import CssBaseline from "@material-ui/core/CssBaseline"
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles"
import "../css/typography.css"
import { setConfiguration } from "react-grid-system"

// MUI breakpoints

// xs, extra-small: 0px
// sm, small: 600px
// md, medium: 960px
// lg, large: 1280px
// xl, extra-large: 1920px

const index = props => {
  setConfiguration({
    defaultScreenClass: "xxl",
    maxScreenClass: "xxl",
    gutterWidth: 60,
    // breakpoints: [600, 960, 1280, 1920, 1920],
    // containerWidths: [600, 960, 1280, 1920, 1920],
  })

  const theme = createMuiTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200,
      },
    },
  })

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {props.children}
    </ThemeProvider>
  )
}

export default index
